import { ICellRendererParams } from "ag-grid-community";

export const makeIndent = (params: ICellRendererParams) => {
  const { level } = params.node;
  const indent = 28;
  return { paddingLeft: (level + 1) * indent + "px" };
};
